shadow$provide[486] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Callback:{enumerable:true, get:function() {
  return Callback;
}}});
var require$_DOT__DOT__SLASH_graph = require("../graph");
var require$_DOT__SLASH_block = require("./block");
class Callback extends require$_DOT__SLASH_block.Block {
  constructor(graph) {
    super(true);
    this.graph = graph;
    this.construct();
  }
  refresh() {
    super.refresh();
    return delete this.subroutine;
  }
  clone() {
    return new Callback(this.graph);
  }
  makeOutlets() {
    let outlet;
    this.make();
    const outlets = [];
    let ins = [];
    let outs = [];
    const handle = (outlet, list) => {
      if (outlet.meta.callback) {
        if (outlet.inout === require$_DOT__DOT__SLASH_graph.Graph.IN) {
          const dupe = outlet.dupe();
          if (dupe.meta.child == null) {
            dupe.meta.child = outlet;
          }
          outlet.meta.parent = dupe;
          return outlets.push(dupe);
        }
      } else {
        return list.push(outlet.type);
      }
    };
    for (outlet of Array.from(this.graph.inputs())) {
      handle(outlet, ins);
    }
    for (outlet of Array.from(this.graph.outputs())) {
      handle(outlet, outs);
    }
    ins = ins.join(",");
    outs = outs.join(",");
    const type = `(${ins})(${outs})`;
    outlets.push({name:"callback", type, inout:require$_DOT__DOT__SLASH_graph.Graph.OUT, meta:{callback:true, def:this.subroutine.main,},});
    return outlets;
  }
  make() {
    return this.subroutine = this.graph.compile(this.namespace);
  }
  export(layout, depth) {
    if (!layout.visit(this.namespace, depth)) {
      return;
    }
    this._link(this.subroutine, layout, depth);
    return this.graph.export(layout, depth);
  }
  call(program, depth) {
    return this._require(this.subroutine, program, depth);
  }
  callback(layout, depth, name, external, outlet) {
    this._include(this.subroutine, layout, depth);
    return this._callback(this.subroutine, layout, depth, name, external, outlet);
  }
}

};